
export enum QuizHomeView {
    notReady = 'not-ready',
    notStarted = 'not-started',
    quiz = 'quiz',
    lastResult = 'lastResult',
    allResults = 'allResults',
    quizAnswers = 'quizAnswers'
}
